import React from 'react'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Profile from './Profile'

const Header = (props) => {
    return(
        <div className="navbar-profile">
            <Link className="navbar-timbrat-mobile" to="/">
                <img alt="Timbrát"  src="/assets/images/logo.svg" />
            </Link>
            <div className="navbar-profile-actions">
                <Profile profile={props.Auth.profile} />
            </div>
        </div>
    )
}

const mapStatetoProps = (state) => {
    const { Auth } = state
    return { Auth }
}

export default connect(mapStatetoProps)(Header)